import { render, staticRenderFns } from "./ResultsAggregationCard.vue?vue&type=template&id=33de1766"
import script from "./ResultsAggregationCard.vue?vue&type=script&lang=js"
export * from "./ResultsAggregationCard.vue?vue&type=script&lang=js"
import style0 from "./ResultsAggregationCard.vue?vue&type=style&index=0&id=33de1766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports